import beneficiaryStatus from 'constants/beneficiaryStatus';
import { calculateConsolidationPercent } from 'utils/consolidationPeriods';
import { Beneficiary, StockPlan } from 'types';

export const isBeneficiaryCanceled = (beneficiary: Beneficiary): boolean =>
  beneficiary?.isCanceled === true;

export const isBeneficiaryPaused = (beneficiary: Beneficiary): boolean => {
  const pause = beneficiary?.pause;

  if (!beneficiary?.isPaused || !pause) {
    return false;
  }

  if (pause.isIndefinite) {
    return true;
  }

  return pause.endDate !== null && new Date(pause.endDate) > new Date();
};

export const getUnits = (beneficiary: Beneficiary): number => {
  const units = isBeneficiaryCanceled(beneficiary)
    ? beneficiary?.finalConsolidatedUnits
    : beneficiary?.sharesCount?.future;
  return units || 0;
};

export const getStatus = (
  beneficiary: Beneficiary,
  planId: string,
  plans: StockPlan[],
  date = Date.now()
): string => {
  const plan = plans?.find((plan) => plan['_id'] === planId);

  let percent: number = 0;
  let currentStatus: string;

  if (!isBeneficiaryCanceled(beneficiary)) {
    percent = calculateConsolidationPercent(date, beneficiary, plan) || 0;
  }

  if (isBeneficiaryPaused(beneficiary)) {
    currentStatus = beneficiaryStatus.var.PAUSED;
    return currentStatus;
  }

  if (isBeneficiaryCanceled(beneficiary)) {
    if (beneficiary?.cancelationOption === beneficiaryStatus.var.CONSOLIDATED) {
      currentStatus = beneficiaryStatus.var.CONSOLIDATED;
    } else {
      currentStatus = beneficiaryStatus.var.CANCELED;
    }
  } else if (percent >= 0 && percent < 100) {
    currentStatus = beneficiaryStatus.var.ACTIVE;
  } else {
    currentStatus = beneficiaryStatus.var.CONSOLIDATED;
  }

  return currentStatus;
};

export const getStatusName = (
  beneficiary: Beneficiary,
  planId: string,
  plans: StockPlan[],
  date = Date.now()
): string => {
  const plan = plans?.find((plan) => plan['_id'] === planId);

  let percent: number = 0;
  let currentStatus: string;

  if (!isBeneficiaryCanceled(beneficiary)) {
    percent = calculateConsolidationPercent(date, beneficiary, plan) || 0;
  }

  if (isBeneficiaryPaused(beneficiary)) {
    currentStatus = beneficiaryStatus.name.PAUSED;
    return currentStatus;
  }

  if (isBeneficiaryCanceled(beneficiary)) {
    currentStatus = beneficiaryStatus.name.CANCELED;
  } else if (percent >= 0 && percent < 100) {
    currentStatus = beneficiaryStatus.name.ACTIVE;
  } else {
    currentStatus = beneficiaryStatus.name.CONSOLIDATED;
  }

  return currentStatus;
};
